import { Employee } from './employee.model';

export class Provider {
  
  public id: string;
  public avatar: string;
  public slug: string;
  public brandName: string;
  public slogan: string;
  public description: string;
  public companyName: string;
  public companyAddress: string;
  public companyCountryCode: string;
  public timezone: string;
  public currency: string;
  public taxId: string;
  public vatRegistered: string;
  public registrationId: string;
  public transactionAccount1: string;
  public phone1: string;
  public email: string;
  public instagram: string;
  public employees: Employee[];

  public _self: string;

  constructor(
    obj?: any 
  ) {
    this.id = obj && obj.id || null;
    this.avatar = obj && obj.avatar || null;
    this.slug = obj && obj.slug || null;
    this.brandName = obj && obj.brandName || null;
    this.slogan = obj && obj.slogan || null;
    this.description = obj && obj.description || null;
    this.companyName = obj && obj.companyName || null;
    this.companyAddress = obj && obj.companyAddress || null;
    this.companyCountryCode = obj && obj.companyCountryCode || null;
    this.timezone = obj && obj.timezone || null;
    this.currency = obj && obj.currency || null;
    this.taxId = obj && obj.taxId || null;
    this.vatRegistered = obj && obj.vatRegistered || null;
    this.registrationId = obj && obj.registrationId || null;
    this.transactionAccount1 = obj && obj.transactionAccount1 || null;
    this.phone1 = obj && obj.phone1 || null;
    this.email = obj && obj.email || null;
    this.instagram = obj && obj.instagram || null;


    if ( obj.employees ) {

      for (let e of obj.employees ) {

       if ( e instanceof Employee ) {
         this.employees.push( e );
       } else {
         this.employees.push( new Employee( e ) );
       }

      }

    }

    if ( obj && obj._self ) {
      this._self = obj._self;

    } else if ( obj && obj._links && obj._links.self && obj._links.self.href ) {
      this._self = obj._links.self.href;
    }

   


  }


  
}